// WhatsApp utilities for TerraHydro

export const WHATSAPP_NUMBER = '5562991953619';
export const PHONE_NUMBER = '556233001656';

export const formatWhatsAppLink = (message = '') => {
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`;
};

export const getDefaultQuoteMessage = (productCode = '', productName = '') => {
  if (productCode && productName) {
    return `Olá! Gostaria de solicitar uma cotação para:\n\n*Código:* ${productCode}\n*Produto:* ${productName}\n\nAguardo retorno.`;
  }
  return `Olá! Gostaria de solicitar uma cotação de peças hidráulicas. Aguardo retorno.`;
};

export const getPhotoIdentificationMessage = () => {
  return `Olá! Preciso identificar uma peça hidráulica. Vou enviar uma foto para análise técnica.`;
};

export const getCategoryQuoteMessage = (categoryName) => {
  return `Olá! Estou interessado em produtos da categoria *${categoryName}*. Gostaria de mais informações.`;
};

export const formatPhoneNumber = (phone) => {
  // Format: (62) 3300-1656
  if (phone.length === 12 && phone.startsWith('556')) {
    const ddd = phone.substring(2, 4);
    const part1 = phone.substring(4, 8);
    const part2 = phone.substring(8);
    return `(${ddd}) ${part1}-${part2}`;
  }
  // Format: (62) 99195-3619
  if (phone.length === 13 && phone.startsWith('55')) {
    const ddd = phone.substring(2, 4);
    const part1 = phone.substring(4, 9);
    const part2 = phone.substring(9);
    return `(${ddd}) ${part1}-${part2}`;
  }
  return phone;
};
